"use strict";
import Auth from "../util/auth";
export default {
  userExceptionSignature() {
    return Auth.getCurrentUser().settings["exceptions_signature"] || this.signatureDefault();
  },
  signatureDefault() {
    return "";
  },
  signatureWithBuffer() {
    var sig = this.userExceptionSignature();
    var whiteSpace = "\n\n";
    if (sig !== this.signatureDefault()) {
      return whiteSpace + sig;
    } else {
      return sig;
    }
  }
};
